// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1KtqP","col":"styles_col__3Ko7i"};